<nav [hidden]="!isVisible" class="navbar navbar-expand-lg navbar-light bg-white">

    <div class="navbar-brand">
      <img [src]="brandLogo" class="logo">
    </div>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto"></ul>
      <lib-auth-links class="form-inline my-2 my-lg-0"></lib-auth-links>
    </div>
  </nav>